import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const navItems = [
    { path: '/', icon: '🏠', label: 'Start' },
    { path: '/lessons', icon: '📚', label: 'Lekcje' },
    { path: '/custom-sets', icon: '📝', label: 'Moje' },
    { path: '/games', icon: '🎮', label: 'Gry' },
    { path: '/dictionary', icon: '📖', label: 'Słownik' },
  ];

  return (
    <div className="layout">
      <header className="header">
        <Link to="/" className="logo">
          <span className="logo-icon">🎓</span>
          <span className="logo-text">YouCanLearn.pl</span>
        </Link>
        {user && (
          <div className="user-menu">
            <span className="user-name">👤 {user.name}</span>
            <button className="logout-btn" onClick={logout} title="Wyloguj">
              🚪
            </button>
          </div>
        )}
      </header>

      <main className="main-content">
        {children}
      </main>

      <nav className="bottom-nav">
        {navItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default Layout;

